<template>
  <div class="user-contact" :class="{ 'app-invalid-group': !isComponentValid }">
    <fieldset>
      <legend>
        <span class="app-required-indicator __after">Contact information</span>
      </legend>
      <div v-if="verifyDetails != '' && verifyDetails != null" class="app-contact-info-text">
        <div v-html="verifyDetails"></div>
      </div>
      <div v-else class="app-contact-info-text">
        <span>The contact information you provide below will be verified to safeguard your information. </span>
        <ul class="contact-info-req">
          <li>
            <span>Enter your contact information, choose the contact information to verify and click on 'Send verification code'.</span>
          </li>
          <li >
            <span >Enter the verification code, choose your reminder preference and click on 'Next'.</span>
          </li>
        </ul>
        <div>
          <b>NOTE:</b> Check your email Spam / Junk folders. <br />
          Please provide cell phone numbers; if you don't receive text message for your code you may have chosen to opt out 
          text messages from RI DMV. To re-enroll text START to {{reEnrollNumber}}.
        </div>
      </div>
      <div class="component-container">
        <ContactPhone :verify="verify" @doPhone="setPhone" @doResetVerify="resetVerify" :embedded="true" :editable="editablePhone"
        v-if="showNotification || editablePhone"/>
        <div class="conjunction" v-if="(showNotification || editableEmail) && (showNotification || editablePhone)">and/or</div>
        <ContactEmail :verify="verify" @doEmail="setEmail" @doResetVerify="resetVerify" :embedded="true" :editable="editableEmail" 
        v-if="showNotification || editableEmail" />
      </div>
    </fieldset>
    <p hidden ref="noContactInfo" class="app-invalid-msg msg-offset-1">
      Either phone or email is required.
    </p>

    <div class="app-input-verify">
      <div class="verify-contact">
        <div class="phone-verify" >
        <input type="radio" id="verifyPhone" name="verify" value="phone" v-model="verifyContact" :disabled="checkContactVerification" :readonly="checkContactVerification">
        <label for="verifyPhone">Verify via Phone</label>
      </div>
      <div class="email-verify" >
        <input type="radio" id="verifyEmail" name="verify" value="email" v-model="verifyContact" :disabled="checkContactVerification" :readonly="checkContactVerification">
        <label for="verifyEmail">Verify via Email</label>
      </div>
      </div>
      <div>
        <button type="button" class="app-btn-primary" @click.prevent="getVerifyContact()">Send verification code</button>
      </div>
    </div>
    <div v-if="isSucess" class="success-msg">
      <p>
        The verification code was sent successfully. You can click on 'Send verification code' code again to resend the code.
      </p>
    </div>
    <div class="app-invalid-msg msg-offset-1" v-if="verifyErrorMsg!=''">
     <p>{{ verifyErrorMsg }}</p> 
      <p class="sr-only">
          {{ verifyErrorMsg }}
      </p>
    </div>
    
    <div class="user-con-details">    
      <div>
        <label class="login-code-text" for="verifcation-code">Verification code</label>         
        <input type="text" id="verifcation-code" maxlength="12" class="verification-code" v-model="otp" :readonly="!activeOtp" :disabled="!activeOtp">
      </div>
      <div class="user-details">
      </div>  
    </div>
    <p v-if="errorMsg" class="app-invalid-msg msg-offset-1">{{ errorMsg }}</p>
    <p v-if="errorMsg" class="sr-only">{{ errorMsg }}</p>
    <p v-if="validationSuccessMessage" class="success-msg">The Verification code you entered was successfully validated</p>
    <p class="app-invalid-msg msg-offset-1" v-if="verifyValidate">
      You must verify and validate the contact information you provided.
    </p>

    <fieldset v-if="showNotification">
      <legend>
        <span class="app-required-indicator __after">
          Send me a confirmation and reminder
        </span>
      </legend>
      <div class="app-input-group">
        <div class="app-input-selector">
          <input type="radio" :id="sendYes" :value="sendYes" name="notify"
                 v-model="myNotification" @click="setNotifyMe">
          <label :for="sendYes">Yes <em>(Message and data rates may apply.)</em></label>
        </div>
        <div class="app-input-selector">
          <input type="radio" :id="sendNo" :value="sendNo" name="notify"
                 v-model="myNotification" @click="setNotifyMe">
          <label :for="sendNo">No</label>
        </div>
      </div>
    </fieldset>
    <p hidden ref="noConsentInfo" class="app-invalid-msg msg-offset-2">
      You must choose "Yes" or "No" to indicate your consent to receive reservation confirmation and reminder.
    </p>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import ContactPhone from '@/components/reservation/user/contact/ContactPhone';
import ContactEmail from '@/components/reservation/user/contact/ContactEmail';
import { usePhoneFormatter } from '@/composables/usePhoneFormatter'; 

const store = useStore();
const props = defineProps({
  verify: {
    type: Boolean,
    required: true,
  },
  verifyDetails: {
    type: String,
  },
  showNotification: {
    type: Boolean,
    default: true
  }
});

// Phone composable
const { formatPhoneForRims } = usePhoneFormatter();

// Emits
const emit = defineEmits(['doContactValidated', 'doResetVerify']);

// Refs for DOM elements
const noContactInfo = ref(null);
const noConsentInfo = ref(null);

// Reactive state variables
const myPhone = ref('');
const myEmail = ref('');
const myNotification = ref(undefined);
const sendYes = 'sendYes';
const sendNo = 'sendNo';
const isComponentValid = ref(true);
const isPhoneValidated = ref(true);
const isEmailValidated = ref(true);
const isModify = ref(false);
const verifyContact = ref('');
const verifyErrorMsg = ref('');
const activeOtp = ref(false);
const verifyOtp = ref(false);
const verifyValidate = ref(false);
const otp = ref('');
const validationSuccessMessage = ref(false);
const errorMsg = ref('');
const editableEmail = ref(false);
const editablePhone = ref(false);
const reEnrollNumber = ref('');
const isSucess = ref(false);

const count = ref(0);

// Computed properties
const reservationSlotId = computed(() => store.state.user.reservationSlotId);
const resDetails = computed(() => store.state.user.resDetails);
const customerDetail = computed(() => store.state.user.customerDetail);

const reservationUserIdentifierOverride = computed(() => customerDetail.value?.reservationUserIdentifier ?? null);

const checkContactVerification = computed(() => {
  return (!editableEmail.value && editablePhone.value) || (editableEmail.value && !editablePhone.value);
});

// Lifecycle hooks
onMounted(async () => {
  // Initial logic previously in created()
  myNotification.value = getIsConsentProvided();

  reEnrollNumber.value = window.config.REENROLLNUMBER;
  if (resDetails.value && resDetails.value.userInfo) {
    const info = resDetails.value.userInfo;
    myPhone.value = info.phone || '';
    myEmail.value = info.email || '';
  }
  isModify.value = await store.dispatch('user/isReservationForUpdate');

  if (customerDetail.value) {
    const info = customerDetail.value;
    editableEmail.value = info.email != '';
    editablePhone.value = info.phone != '';
    if(editableEmail.value && !editablePhone.value) {
      verifyContact.value = 'email';
    }
    if(editablePhone.value && !editableEmail.value) {
      verifyContact.value = 'phone';
    }
  }
  if(!props.showNotification) {
    myNotification.value = 'sendNo';
  }
  if(myEmail.value == '' && myPhone.value !='' ) {
    verifyContact.value = 'phone';
  }
  if(myPhone.value == '' && myEmail.value !='' ) {
    verifyContact.value = 'email';
  }
});

// Methods 
const continueToNextStep = async () => {
  const hasContact = await hasContactInfo();
  toggleRequirementError();
  isComponentValid.value = (hasContact && myNotification.value !== undefined);
  
  if (isComponentValid.value) {
    isSucess.value = false;
    if(props.showNotification) {
      await checkWithoutMfaRequest();
    } else {
      await checkWithMfaRequest();
    }
  } else {
    resetVerify();
  }
};

const checkWithMfaRequest = async () => {
  if(otp.value != '' && otp.value != null) {
    count.value++;
    let data = { 
      verificationCode: otp.value,
      reservationUserIdentifier: reservationUserIdentifierOverride.value,
      attemptCount: count.value
    };
    validationSuccessMessage.value = false;
    errorMsg.value = '';

    let result = await store.dispatch('reservation/setVerifyMfaRequest', data); 
    try {
      if(result && result.isSucess) {
        validationSuccessMessage.value = result.isSucess;
        activeOtp.value = false;
        verifyValidate.value = false;
        isSucess.value = false;
        emit('doContactValidated', {
          phone: myPhone.value,
          email: myEmail.value,
          oneTimeOtp: otp.value, 
          isConsentProvided: (myNotification.value === sendYes),
          isModifyRequest: isModify.value,
          verifiedContactType: verifyContact.value, // 'email' or 'phone' — whichever the user chose for OTP
        });
        otp.value = '';
        isSucess.value = false;
      } else {
        errorMsg.value = result ? result.errorMessage : '';
      }
    } catch (error) {
      console.log(error);
    }
  } else {
    errorMsg.value = 'Verification code is required';
  }
};

const checkWithoutMfaRequest = () => {
  if(otp.value != '' && otp.value != null) {
    validationSuccessMessage.value = false;
    errorMsg.value = '';
    isSucess.value = false;
    try {
      activeOtp.value = true;
      verifyValidate.value = false;
      emit('doContactValidated', {
        phone: myPhone.value,
        email: myEmail.value,
        oneTimeOtp: otp.value, 
        isConsentProvided: (myNotification.value === sendYes),
        isModifyRequest: isModify.value,
        verifiedContactType: verifyContact.value, // 'email' or 'phone' — whichever the user chose for OTP
      });
      otp.value = '';
      isSucess.value = false;
    } catch (error) {
      console.log(error);
    }
  } else {
    errorMsg.value = 'Verification code is required';
  }
};

const getIsConsentProvided = () => {
  if (reservationSlotId.value > 0 && resDetails.value?.userInfo) {
    const userContact = resDetails.value.userInfo.reservationSendConfirmationRequest;
    if (userContact && userContact.isConsentProvided !== undefined) {
      return (userContact.isConsentProvided ? sendYes : sendNo);
    }
  }
  return undefined;
};

const handleHidden = (data) => {
  const attr = 'hidden';
  const errorElem = data.ref === 'noContactInfo' ? noContactInfo.value : noConsentInfo.value; 
  const hasError = data.error;
  if (errorElem) {
    if (hasError) {
      errorElem.removeAttribute(attr);
    } 
    else if (!errorElem.hasAttribute(attr)) {
      errorElem.setAttribute(attr, attr);
    }
  }
};

const hasContactInfo = () => {
  return (myPhone.value.length > 0 || myEmail.value.length > 0);
};

const resetVerify = () => {
  isPhoneValidated.value = false;
  isEmailValidated.value = false;
  emit('doResetVerify');
};

const setEmail = (data) => {
  myEmail.value = data.email;
  isEmailValidated.value = data.isValid;
  if (props.verify && isEmailValidated.value && isPhoneValidated.value && verifyContact.value != 'phone') {
    continueToNextStep();
  }
};

const setPhone = (data) => {
  myPhone.value = data.phone;
  isPhoneValidated.value = data.isValid;
  if (props.verify && isPhoneValidated.value && isEmailValidated.value && verifyContact.value != 'email') {
    continueToNextStep();
  }
};

const setNotifyMe = (e) => {
  myNotification.value = e.target.value;
};

const toggleRequirementError = async () => {
  handleHidden({ ref: 'noContactInfo', error: !hasContactInfo() });
  await nextTick(); 

  if(props.showNotification) {
    const isConsentError = myNotification.value === undefined || myNotification.value === null || myNotification.value === '';
    handleHidden({ ref: 'noConsentInfo', error: isConsentError });
  }
  
  verifyValidate.value = (!activeOtp.value && !verifyOtp.value);
  if(verifyContact.value == '') {
    verifyErrorMsg.value = 'Either phone or email verification is required.';
  }
};

const getVerifyContact = async () => {
  verifyErrorMsg.value = '';

  const contactType = verifyContact.value;

  if (!['email', 'phone'].includes(contactType)) {
    verifyErrorMsg.value = 'You should select one of the option';
    return;
  }

  const contactValue = contactType === 'email' ? myEmail.value : myPhone.value;

  const isValidated = contactType === 'email' ? isEmailValidated.value : isPhoneValidated.value;

  if (!contactValue && isValidated) {
    verifyErrorMsg.value = 'The contact information you chose to verify is missing above.';
    return;
  }

  const mfaData = {
    mfaType: contactType === 'email' ? 2 : 1,
    mfaTypeValue: contactType === 'email' ? contactValue : formatPhoneForRims(contactValue),
    reservationUserIdentifier: reservationUserIdentifierOverride.value,
  };

  try {
    const result = await store.dispatch('reservation/setMfaRequest', mfaData);

    if (result) {
      isSucess.value = result?.mfaResponse?.isSucess;
    }

    otp.value = '';
    
  } catch (error) {
    console.error(error);
  }
  activeOtp.value = true;
};

defineExpose({
  continueToNextStep,
  handleHidden,
  toggleRequirementError,
})
</script>

<style lang="scss" scoped>
.user-contact {
  border: 1px solid var(--ri-gray);
  margin: 0.5em 0 1.5em;
  padding: calc(var(--padding-horizontal) * 0.125) calc(var(--padding-horizontal) * 0.35);

  .app-contact-info-text{
    margin-bottom: 15px;
    .contact-info-req{
      list-style: auto; 
      padding: 0 35px; 
      margin: 10px 0
    }

  }
  .component-container {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    .conjunction {
      // do not use flex alignment due to conditional error <p>
      line-height: 2em;
      padding: 0 0.75em;
      margin-top: 0;
      @media (min-width: 355px) {
        margin-top: 2.5em;
      }
    }

  }
  .app-input-verify {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    gap: 2.5rem;

    .verify-contact{
      display: flex;
      gap: 1rem;
      .phone-verify, .email-verify {
        input[type="radio"] {
          margin: 0.2em 0;
        }
      }
    }
  }
  .user-con-details{
    display: flex;
    gap: 2rem;
    align-items: flex-end;
    margin-bottom: 1rem;
    .verification-code {
      width: 255px;
    }
    .user-details{
      display: flex;
      gap: 2rem;
    }
  }
  &.app-invalid-group {     // does not override main's app-invalid-group but as a scrollIntoView indicator
    border: 1px solid var(--ri-red);
    box-shadow: 0 0 2px 2px var(--ri-red);
  }
  input[type="radio"] {
    margin: 0.5em 0;
  }
  .msg-offset {
    &-1 {
      margin-top: -1.25em;
      margin-bottom: 1em;
    }
    &-2 {
      margin-top: -1em;
      margin-bottom: 0.5em;
    }
  }
  .success-msg {
    color: #008000;
  }
}

@media only screen and (min-width: 300px) and (max-width: 500px) {
  .user-contact {
    .component-container {
      display: flex;
    }
    .app-contact-info-text{
      margin-bottom: 15px;
    }
    .app-input-verify {
      display: block;
      margin-top: 0rem;
      .verify-contact {
        display: flex;
        gap: 1rem;
        margin-bottom: 1rem;
        .phone-verify, .email-verify {
          input[type="radio"] {
            margin: 0.2em 0;
          }
        }
      }
    }
    .user-con-details{
      display: block;
      .verification-code {
        width: 200px;
      }
      .user-details{
        display: block;
        .resend-code, .validate-code {
          margin-top: 1rem;
        }
      }
    }
  }
}

@media only screen and (min-width: 501px) and (max-width: 780px) {
  .user-contact {
    .component-container {
      display: flex;
    }
    .app-contact-info-text{
      margin-bottom: 15px;
    }
    .app-input-verify {
      display: block;
      margin-top: 0rem;
      .verify-contact {
        display: flex;
        gap: 1rem;
        margin-bottom: 1rem;
        .phone-verify, .email-verify {
          input[type="radio"] {
            margin: 0.2em 0;
          }
        }
      }
    }
    .user-con-details{
      display: block;
      .verification-code {
        width: 200px;
      }
      .user-details{
        .resend-code, .validate-code {
          margin-top: 1rem;
        }
        .resend-code[disabled] {
          background-color: white; 
          color: var(--ri-blue);
        }
      }
    }
  }
}

@media only screen and (min-width: 781px) and (max-width: 900px) {
  .user-contact {
    .component-container {
      display: flex;
    }
    .app-contact-info-text{
      margin-bottom: 15px;
    }
    .app-input-verify {
      display: block;
      margin-top: 0rem;
      .verify-contact {
        display: flex;
        gap: 1rem;
        margin-bottom: 1rem;
        .phone-verify, .email-verify {
          input[type="radio"] {
            margin: 0.2em 0;
          }
        }
      }
    }
    .user-con-details{
      display: flex;
      .verification-code {
        width: 200px;
      }
      .user-details{
        display: flex;
      }
    }
  }
}
</style>

